import React, { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import Header from "./Header";
import AddCircleOutlineTwoToneIcon from "@mui/icons-material/AddCircleOutlineTwoTone";
import EditIcon from "@mui/icons-material/Edit";
import CloseIcon from "@mui/icons-material/Close";
import { MenuItem, Select } from "@mui/material";
import ReactLoading from "react-loading";
import api from "../services/api";
import toast from 'react-hot-toast';
export default function AddProduct() {
  const { id } = useParams();
  const navigate = useNavigate();
  const isEditMode = !!id;

  const [product, addproduct] = useState({
    ProductName: "",
    ProductMRP: "",
    ProductPrice: "",
    ProductMainImgUrl: "",
    ProductShortDesc: "",
    ProductLongDesc: "",
    ProductColor: "",
    ProductCategory: "",
    ProductSubCategory: "",
    ProductBrand: "",
    ProductSize: "",
    ProductQuantity: "",
    ProductDiscount: "",
    ProductGST: "",
    ProductHSN: "",
  });

  const [productPricing, setProductPricing] = useState({
    "250g": { price: "", mrp: "" },
    "500g": { price: "", mrp: "" },
    "1kg": { price: "", mrp: "" },
  });
  const [loading, setloading] = useState(false);
  const [productCategories, setproductCategories] = useState([]);
  const [productSubCategories, setproductSubCategories] = useState([]);
  const [CategoryModel, setCategoryModel] = useState(false);
  const [SubCategoryModel, setSubCategoryModel] = useState(false);
  const [categoryData, setCategoryData] = useState({ name: "", image: null });
  const [subCategoryData, setsubCategoryData] = useState({
    CategoryId: "",
    name: "",
    image: null,
  });
  const [filteredSubCategories, setFilteredSubCategories] = useState([]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    addproduct({ ...product, [name]: value });
  };

  const handlePricingChange = (weight, field, value) => {
    setProductPricing({
      ...productPricing,
      [weight]: {
        ...productPricing[weight],
        [field]: value,
      },
    });
  };

  const handleFileChange = (e) => {
    const file = e.target.files[0];
    addproduct({ ...product, ProductMainImgUrl: file });
  };

  const getCategory = async () => {
    try {
      const res = await api.get("/categories");
      setproductCategories(res.data);
    } catch (error) {
      toast.error("Failed to fetch categories");
    }
  };

  const getSubCategory = async () => {
    try {
      const res = await api.get("/subcategories");
      setproductSubCategories(res.data);
    } catch (error) {
      toast.error("Failed to fetch subcategories");
    }
  };

  const fetchProductData = async () => {
    if (!id) return;
    try {
      setloading(true);
      const res = await api.get(`/getproduct/${id}`);
      if (res.data) {
        const productData = res.data.data;
        addproduct({
          ProductName: productData.ProductName || "",
          ProductMRP: productData.ProductMRP || "",
          ProductPrice: productData.ProductPrice || "",
          ProductMainImgUrl: productData.ProductMainImgUrl || "",
          ProductShortDesc: productData.ProductShortDesc || "",
          ProductLongDesc: productData.ProductLongDesc || "",
          ProductColor: productData.ProductColor || "",
          ProductCategory: productData.ProductCategory?._id || productData.ProductCategory || "",
          ProductSubCategory: productData.ProductSubCategory?._id || productData.ProductSubCategory || "",
          ProductBrand: productData.ProductBrand || "",
          ProductSize: productData.ProductSize || "",
          ProductQuantity: productData.ProductQuantity || "",
          ProductDiscount: productData.ProductDiscount || "",
          ProductGST: productData.ProductGST || "",
          ProductHSN: productData.ProductHSN || "",
        });

        // Populate ProductPricing if it exists
        if (productData.ProductPricing) {
          const pricing = {};
          Object.keys(productData.ProductPricing).forEach((weight) => {
            pricing[weight] = {
              price: productData.ProductPricing[weight].price || "",
              mrp: productData.ProductPricing[weight].mrp || "",
            };
          });
          setProductPricing({
            "250g": pricing["250g"] || { price: "", mrp: "" },
            "500g": pricing["500g"] || { price: "", mrp: "" },
            "1kg": pricing["1kg"] || { price: "", mrp: "" },
          });
        }
      }
    } catch (error) {
      toast.error("Failed to fetch product data");
    } finally {
      setloading(false);
    }
  };

  useEffect(() => {
    getCategory();
    getSubCategory();
    if (isEditMode && id) {
      fetchProductData();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [id]);

  const handleCategoryFileChange = (e) => {
    const file = e.target.files[0];
    setCategoryData({ ...categoryData, image: file });
  };

  const handleSubCategoryFileChange = (e) => {
    const file = e.target.files[0];
    setsubCategoryData({ ...subCategoryData, image: file });
  };

  const handleAddCategory = async () => {
    setloading(true);
    try {
      if (!categoryData.name) {
        toast.error("Select or Create Category");
        setloading(false);
        return;
      }

      const formData = new FormData();
      formData.append("CategoryName", categoryData.name);
      formData.append("image", categoryData.image);

      if (categoryData.description) {
        formData.append("description", categoryData.description);
      }

      let res = await api.post("/categories", formData);

      if (res.data) {
        setloading(false);
        toast.success(res.data.message);
        setCategoryModel(false);
        setCategoryData({ name: "", image: null });
        getCategory();
      }
    } catch (err) {
      toast.error("Try again");
      setloading(false);
      setCategoryModel(false);
    }
  };

  const handleSubAddCategory = async () => {
    setloading(true);
    try {
      if (!subCategoryData.name) {
        toast.error("Select or Create Sub Category");
        setloading(false);
        return;
      }

      const formData = new FormData();
      formData.append("CategoryId", subCategoryData.CategoryId);
      formData.append("SubCategoryName", subCategoryData.name);
      formData.append("image", subCategoryData.image);

      if (subCategoryData.description) {
        formData.append("description", subCategoryData.description);
      }

      let res = await api.post("/subcategories", formData);

      if (res.data) {
        setloading(false);
        toast.success(res.data.message);
        setSubCategoryModel(false);
        setsubCategoryData({ CategoryId: "", name: "", image: null });
        getSubCategory();
      }
    } catch (err) {
      toast.error("Try again");
      setloading(false);
      setSubCategoryModel(false);
    }
  };

  const validateForm = () => {
    if (!product.ProductPrice) {
      toast.error("Enter Product Price");
      return true;
    }
    if (!product.ProductName) {
      toast.error("Enter Product Name");
      return true;
    }
    if (!product.ProductMRP) {
      toast.error("Enter Product MRP");
      return true;
    }
    if (!product.ProductCategory || product.ProductCategory === "") {
      toast.error("Select Product Category");
      return true;
    }
    if (!product.ProductSubCategory || product.ProductSubCategory === "") {
      toast.error("Select Product Sub Category");
      return true;
    }
    return false;
  };

  useEffect(() => {
    if (product.ProductCategory) {
      const filtered = productSubCategories.filter(
        (subCategory) => subCategory.CategoryId._id === product.ProductCategory
      );
      setFilteredSubCategories(filtered);
    } else {
      setFilteredSubCategories([]);
    }
  }, [product.ProductCategory, productSubCategories]);

  const handleSubmit = async () => {
    setloading(true);
    if (validateForm()) {
      setloading(false);
      return;
    }
    try {
      const formData = new FormData();
      formData.append("ProductName", product.ProductName);
      formData.append("ProductMRP", product.ProductMRP);
      formData.append("ProductPrice", product.ProductPrice);

      // Only append image if it's a new file upload
      if (product.ProductMainImgUrl instanceof File) {
        formData.append("ProductMainImgUrl", product.ProductMainImgUrl);
      }

      formData.append("ProductShortDesc", product.ProductShortDesc);
      formData.append("ProductLongDesc", product.ProductLongDesc);
      formData.append("ProductColor", product.ProductColor);
      formData.append("ProductCategory", product.ProductCategory);
      formData.append("ProductSubCategory", product.ProductSubCategory);
      formData.append("ProductBrand", product.ProductBrand);
      formData.append("ProductSize", product.ProductSize);
      formData.append("ProductQuantity", product.ProductQuantity);
      formData.append("ProductDiscount", product.ProductDiscount);
      formData.append("ProductGST", product.ProductGST);
      formData.append("ProductHSN", product.ProductHSN);

      // Add ProductPricing as JSON string
      formData.append("ProductPricing", JSON.stringify(productPricing));

      let res;
      if (isEditMode) {
        res = await api.put(`/updateProduct/${id}`, formData);
      } else {
        res = await api.post("/AddProduct", formData);
      }

      if (res.data) {
        setloading(false);
        toast.success(res.data.message);
        setTimeout(() => {
          navigate("/admin/Products");
        }, 1500);
      }
    } catch (err) {
      toast.error("Try again");
      setloading(false);
    }
  };

  return (
    <div className="min-h-screen bg-gray-50">
      <Header />
      <main className="md:ml-72 pt-16 md:pt-20 p-4 md:p-6">
        {/* Header */}
        <div className="mb-6 flex items-center gap-3">
          {isEditMode ? (
            <EditIcon className="text-purple-600 text-3xl" />
          ) : (
            <AddCircleOutlineTwoToneIcon className="text-purple-600 text-3xl" />
          )}
          <h1 className="text-2xl md:text-3xl font-bold text-gray-800">
            {isEditMode ? "Edit Product" : "Add a Product"}
          </h1>
        </div>

        {loading ? (
          <div className="flex justify-center items-center min-h-[400px]">
            <ReactLoading type="spin" color="#6945ff" height={200} width={100} />
          </div>
        ) : (
          <div className="bg-white rounded-xl shadow-lg p-6 md:p-8">
            <form className="space-y-6">
              {/* Grid Container */}
              <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                {/* Product Name */}
                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-2">
                    Product Name <span className="text-red-500">*</span>
                  </label>
                  <input
                    type="text"
                    value={product.ProductName}
                    name="ProductName"
                    onChange={handleChange}
                    className="w-full px-4 py-3 border border-gray-300 rounded-lg text-black focus:ring-2 focus:ring-purple-500 focus:border-transparent outline-none transition-all"
                    placeholder="Enter product name"
                  />
                </div>

                {/* Product MRP */}
                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-2">
                    Product MRP <span className="text-red-500">*</span>
                  </label>
                  <input
                    type="number"
                    value={product.ProductMRP}
                    name="ProductMRP"
                    onChange={handleChange}
                    className="w-full px-4 py-3 border border-gray-300 rounded-lg text-black focus:ring-2 focus:ring-purple-500 focus:border-transparent outline-none transition-all"
                    placeholder="Enter MRP"
                  />
                </div>

                {/* Product Price */}
                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-2">
                    Product Price <span className="text-red-500">*</span>
                  </label>
                  <input
                    type="number"
                    value={product.ProductPrice}
                    name="ProductPrice"
                    onChange={handleChange}
                    className="w-full px-4 py-3 border border-gray-300 rounded-lg text-black focus:ring-2 focus:ring-purple-500 focus:border-transparent outline-none transition-all"
                    placeholder="Enter price"
                  />
                </div>
              </div>

              {/* Weight-Based Pricing Section */}
              <div className="mt-6 p-6 bg-gradient-to-r from-purple-50 to-blue-50 rounded-lg border-2 border-purple-200">
                <h3 className="text-lg font-bold text-gray-800 mb-4 flex items-center gap-2">
                  <span className="text-purple-600">⚖️</span>
                  Weight-Based Pricing (for Dry Fruits)
                </h3>
                <p className="text-sm text-gray-600 mb-4">
                  Set different prices for different weight options. Leave blank if not applicable.
                </p>

                <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
                  {/* 250g Pricing */}
                  <div className="bg-white p-4 rounded-lg border border-gray-200">
                    <h4 className="font-semibold text-gray-700 mb-3 text-center">250g</h4>
                    <div className="space-y-3">
                      <div>
                        <label className="block text-xs font-medium text-gray-600 mb-1">
                          Price (₹)
                        </label>
                        <input
                          type="number"
                          value={productPricing["250g"].price}
                          onChange={(e) => handlePricingChange("250g", "price", e.target.value)}
                          className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-purple-500 focus:border-transparent outline-none transition-all text-sm"
                          placeholder="299"
                        />
                      </div>
                      <div>
                        <label className="block text-xs font-medium text-gray-600 mb-1">
                          MRP (₹)
                        </label>
                        <input
                          type="number"
                          value={productPricing["250g"].mrp}
                          onChange={(e) => handlePricingChange("250g", "mrp", e.target.value)}
                          className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-purple-500 focus:border-transparent outline-none transition-all text-sm"
                          placeholder="399"
                        />
                      </div>
                    </div>
                  </div>

                  {/* 500g Pricing */}
                  <div className="bg-white p-4 rounded-lg border border-gray-200">
                    <h4 className="font-semibold text-gray-700 mb-3 text-center">500g</h4>
                    <div className="space-y-3">
                      <div>
                        <label className="block text-xs font-medium text-gray-600 mb-1">
                          Price (₹)
                        </label>
                        <input
                          type="number"
                          value={productPricing["500g"].price}
                          onChange={(e) => handlePricingChange("500g", "price", e.target.value)}
                          className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-purple-500 focus:border-transparent outline-none transition-all text-sm"
                          placeholder="549"
                        />
                      </div>
                      <div>
                        <label className="block text-xs font-medium text-gray-600 mb-1">
                          MRP (₹)
                        </label>
                        <input
                          type="number"
                          value={productPricing["500g"].mrp}
                          onChange={(e) => handlePricingChange("500g", "mrp", e.target.value)}
                          className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-purple-500 focus:border-transparent outline-none transition-all text-sm"
                          placeholder="699"
                        />
                      </div>
                    </div>
                  </div>

                  {/* 1kg Pricing */}
                  <div className="bg-white p-4 rounded-lg border border-gray-200">
                    <h4 className="font-semibold text-gray-700 mb-3 text-center">1kg</h4>
                    <div className="space-y-3">
                      <div>
                        <label className="block text-xs font-medium text-gray-600 mb-1">
                          Price (₹)
                        </label>
                        <input
                          type="number"
                          value={productPricing["1kg"].price}
                          onChange={(e) => handlePricingChange("1kg", "price", e.target.value)}
                          className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-purple-500 focus:border-transparent outline-none transition-all text-sm"
                          placeholder="999"
                        />
                      </div>
                      <div>
                        <label className="block text-xs font-medium text-gray-600 mb-1">
                          MRP (₹)
                        </label>
                        <input
                          type="number"
                          value={productPricing["1kg"].mrp}
                          onChange={(e) => handlePricingChange("1kg", "mrp", e.target.value)}
                          className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-purple-500 focus:border-transparent outline-none transition-all text-sm"
                          placeholder="1299"
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                {/* Product Short Description */}
                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-2">
                    Product Short Description
                  </label>
                  <input
                    type="text"
                    value={product.ProductShortDesc}
                    name="ProductShortDesc"
                    onChange={handleChange}
                    className="w-full px-4 py-3 border border-gray-300 rounded-lg text-black focus:ring-2 focus:ring-purple-500 focus:border-transparent outline-none transition-all"
                    placeholder="Enter short description"
                  />
                </div>

                {/* Product Long Description */}
                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-2">
                    Product Long Description
                  </label>
                  <textarea
                    value={product.ProductLongDesc}
                    name="ProductLongDesc"
                    onChange={handleChange}
                    rows={3}
                    className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-purple-500 focus:border-transparent outline-none transition-all resize-none"
                    placeholder="Enter long description"
                  />
                </div>

                {/* Product Main Image */}
                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-2">
                    Product Main Image
                  </label>
                  <input
                    type="file"
                    accept="image/*"
                    name="ProductMainImgUrl"
                    onChange={handleFileChange}
                    className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-purple-500 focus:border-transparent outline-none transition-all file:mr-4 file:py-2 file:px-4 file:rounded-lg file:border-0 file:text-sm file:font-semibold file:bg-purple-50 file:text-purple-700 hover:file:bg-purple-100"
                  />
                </div>

                {/* Product Category */}
                <div>
                  <div className="flex justify-between items-center mb-2">
                    <label className="block text-sm font-medium text-gray-700">
                      Product Category <span className="text-red-500">*</span>
                    </label>
                    <button
                      type="button"
                      onClick={() => setCategoryModel(true)}
                      className="text-blue-600 hover:text-blue-700 underline text-sm font-medium transition-colors"
                    >
                      Create Category
                    </button>
                  </div>
                  <Select
                    value={product.ProductCategory}
                    name="ProductCategory"
                    onChange={handleChange}
                    className="w-full"
                    sx={{
                      height: "48px",
                      "& .MuiOutlinedInput-notchedOutline": {
                        borderColor: "#d1d5db",
                      },
                      "&:hover .MuiOutlinedInput-notchedOutline": {
                        borderColor: "#6945ff",
                      },
                      "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
                        borderColor: "#6945ff",
                        borderWidth: "2px",
                      },
                    }}
                  >
                    <MenuItem value="">
                      <em>None</em>
                    </MenuItem>
                    {productCategories.map((category) => (
                      <MenuItem key={category._id} value={category._id}>
                        {category.CategoryName}
                      </MenuItem>
                    ))}
                  </Select>
                </div>

                {/* Product Sub Category */}
                <div>
                  <div className="flex justify-between items-center mb-2">
                    <label className="block text-sm font-medium text-gray-700">
                      Product Sub Category <span className="text-red-500">*</span>
                    </label>
                    <button
                      type="button"
                      onClick={() => setSubCategoryModel(true)}
                      className="text-blue-600 hover:text-blue-700 underline text-sm font-medium transition-colors"
                    >
                      Create Sub Category
                    </button>
                  </div>
                  <Select
                    value={product.ProductSubCategory}
                    name="ProductSubCategory"
                    onChange={handleChange}
                    className="w-full"
                    disabled={!product.ProductCategory}
                    sx={{
                      height: "48px",
                      "& .MuiOutlinedInput-notchedOutline": {
                        borderColor: "#d1d5db",
                      },
                      "&:hover .MuiOutlinedInput-notchedOutline": {
                        borderColor: "#6945ff",
                      },
                      "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
                        borderColor: "#6945ff",
                        borderWidth: "2px",
                      },
                    }}
                  >
                    <MenuItem value="">
                      <em>None</em>
                    </MenuItem>
                    {filteredSubCategories.map((category) => (
                      <MenuItem key={category._id} value={category._id}>
                        {category.SubCategoryName}
                      </MenuItem>
                    ))}
                  </Select>
                </div>

                {/* Product Brand */}
                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-2">
                    Product Brand
                  </label>
                  <input
                    type="text"
                    value={product.ProductBrand}
                    name="ProductBrand"
                    onChange={handleChange}
                    className="w-full px-4 py-3 border border-gray-300 rounded-lg text-black focus:ring-2 focus:ring-purple-500 focus:border-transparent outline-none transition-all"
                    placeholder="Enter brand name"
                  />
                </div>

                {/* Product Color */}
                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-2">
                    Product Color
                  </label>
                  <input
                    type="text"
                    value={product.ProductColor}
                    name="ProductColor"
                    onChange={handleChange}
                    className="w-full px-4 py-3 border border-gray-300 rounded-lg text-black focus:ring-2 focus:ring-purple-500 focus:border-transparent outline-none transition-all"
                    placeholder="Enter color"
                  />
                </div>

                {/* Product Size */}
                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-2">
                    Product Size
                  </label>
                  <input
                    type="text"
                    value={product.ProductSize}
                    name="ProductSize"
                    onChange={handleChange}
                    className="w-full px-4 py-3 border border-gray-300 rounded-lg text-black focus:ring-2 focus:ring-purple-500 focus:border-transparent outline-none transition-all"
                    placeholder="Enter size"
                  />
                </div>

                {/* Product Quantity */}
                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-2">
                    Product Quantity
                  </label>
                  <input
                    type="number"
                    value={product.ProductQuantity}
                    name="ProductQuantity"
                    onChange={handleChange}
                    className="w-full px-4 py-3 border border-gray-300 rounded-lg text-black focus:ring-2 focus:ring-purple-500 focus:border-transparent outline-none transition-all"
                    placeholder="Enter quantity"
                  />
                </div>

                {/* Product Discount */}
                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-2">
                    Product Discount (%)
                  </label>
                  <input
                    type="number"
                    value={product.ProductDiscount}
                    name="ProductDiscount"
                    onChange={handleChange}
                    className="w-full px-4 py-3 border border-gray-300 rounded-lg text-black focus:ring-2 focus:ring-purple-500 focus:border-transparent outline-none transition-all"
                    placeholder="Enter discount percentage"
                  />
                </div>

                {/* Product GST */}
                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-2">
                    Product GST (%)
                  </label>
                  <input
                    type="number"
                    value={product.ProductGST}
                    name="ProductGST"
                    onChange={handleChange}
                    className="w-full px-4 py-3 border border-gray-300 rounded-lg text-black focus:ring-2 focus:ring-purple-500 focus:border-transparent outline-none transition-all"
                    placeholder="Enter GST percentage"
                  />
                </div>

                {/* Product HSN */}
                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-2">
                    Product HSN
                  </label>
                  <input
                    type="text"
                    value={product.ProductHSN}
                    name="ProductHSN"
                    onChange={handleChange}
                    className="w-full px-4 py-3 border border-gray-300 rounded-lg text-black focus:ring-2 focus:ring-purple-500 focus:border-transparent outline-none transition-all"
                    placeholder="Enter HSN code"
                  />
                </div>
              </div>

              {/* Submit Button */}
              <div className="pt-4">
                <button
                  type="button"
                  onClick={handleSubmit}
                  className="w-full md:w-auto px-8 py-3 bg-gradient-to-r from-purple-600 to-blue-600 text-white rounded-lg font-semibold hover:from-purple-700 hover:to-blue-700 transition-all duration-200 shadow-lg hover:shadow-xl"
                >
                  {isEditMode ? "Update Product" : "Add Product"}
                </button>
              </div>
            </form>
          </div>
        )}

        {/* Create Category Modal */}
        {CategoryModel && (
          <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4">
            <div className="bg-white rounded-xl shadow-2xl max-w-md w-full">
              <div className="flex justify-between items-center p-6 border-b">
                <h2 className="text-2xl font-bold text-gray-800">
                  Create Category
                </h2>
                <button
                  onClick={() => {
                    setCategoryModel(false);
                    setCategoryData({ name: "", image: null });
                  }}
                  className="text-gray-500 hover:text-gray-700 p-2 hover:bg-gray-100 rounded-lg transition-colors"
                >
                  <CloseIcon />
                </button>
              </div>
              <div className="p-6 space-y-4">
                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-2">
                    Category Name
                  </label>
                  <input
                    type="text"
                    name="name"
                    value={categoryData.name || ""}
                    onChange={(e) =>
                      setCategoryData({ ...categoryData, name: e.target.value })
                    }
                    className="w-full px-4 py-3 border border-gray-300 rounded-lg text-black focus:ring-2 focus:ring-purple-500 focus:border-transparent outline-none transition-all"
                    placeholder="Enter category name"
                  />
                </div>
                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-2">
                    Category Image
                  </label>
                  <input
                    type="file"
                    accept="image/*"
                    name="image"
                    onChange={handleCategoryFileChange}
                    className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-purple-500 focus:border-transparent outline-none transition-all file:mr-4 file:py-2 file:px-4 file:rounded-lg file:border-0 file:text-sm file:font-semibold file:bg-purple-50 file:text-purple-700 hover:file:bg-purple-100"
                  />
                </div>
              </div>
              <div className="flex justify-end gap-4 p-6 border-t">
                <button
                  onClick={() => {
                    setCategoryModel(false);
                    setCategoryData({ name: "", image: null });
                  }}
                  className="px-6 py-2 border border-gray-300 text-gray-700 rounded-lg hover:bg-gray-50 transition-colors font-medium"
                >
                  Cancel
                </button>
                <button
                  onClick={handleAddCategory}
                  className="px-6 py-2 bg-gradient-to-r from-purple-600 to-blue-600 text-white rounded-lg hover:from-purple-700 hover:to-blue-700 transition-all duration-200 font-medium"
                >
                  Create Category
                </button>
              </div>
            </div>
          </div>
        )}

        {/* Create Sub Category Modal */}
        {SubCategoryModel && (
          <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4">
            <div className="bg-white rounded-xl shadow-2xl max-w-md w-full">
              <div className="flex justify-between items-center p-6 border-b">
                <h2 className="text-2xl font-bold text-gray-800">
                  Create Sub Category
                </h2>
                <button
                  onClick={() => {
                    setSubCategoryModel(false);
                    setsubCategoryData({ CategoryId: "", name: "", image: null });
                  }}
                  className="text-gray-500 hover:text-gray-700 p-2 hover:bg-gray-100 rounded-lg transition-colors"
                >
                  <CloseIcon />
                </button>
              </div>
              <div className="p-6 space-y-4">
                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-2">
                    Product Category
                  </label>
                  <Select
                    value={subCategoryData.CategoryId}
                    name="CategoryId"
                    onChange={(e) =>
                      setsubCategoryData({
                        ...subCategoryData,
                        CategoryId: e.target.value,
                      })
                    }
                    className="w-full"
                    sx={{
                      height: "48px",
                      "& .MuiOutlinedInput-notchedOutline": {
                        borderColor: "#d1d5db",
                      },
                      "&:hover .MuiOutlinedInput-notchedOutline": {
                        borderColor: "#6945ff",
                      },
                      "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
                        borderColor: "#6945ff",
                        borderWidth: "2px",
                      },
                    }}
                  >
                    <MenuItem value="">
                      <em>None</em>
                    </MenuItem>
                    {productCategories.map((category) => (
                      <MenuItem key={category._id} value={category._id}>
                        {category.CategoryName}
                      </MenuItem>
                    ))}
                  </Select>
                </div>
                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-2">
                    Sub Category Name
                  </label>
                  <input
                    type="text"
                    name="name"
                    value={subCategoryData.name || ""}
                    onChange={(e) =>
                      setsubCategoryData({
                        ...subCategoryData,
                        name: e.target.value,
                      })
                    }
                    className="w-full px-4 py-3 border border-gray-300 rounded-lg text-black focus:ring-2 focus:ring-purple-500 focus:border-transparent outline-none transition-all"
                    placeholder="Enter sub category name"
                  />
                </div>
                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-2">
                    Sub Category Image
                  </label>
                  <input
                    type="file"
                    accept="image/*"
                    name="image"
                    onChange={handleSubCategoryFileChange}
                    className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-purple-500 focus:border-transparent outline-none transition-all file:mr-4 file:py-2 file:px-4 file:rounded-lg file:border-0 file:text-sm file:font-semibold file:bg-purple-50 file:text-purple-700 hover:file:bg-purple-100"
                  />
                </div>
              </div>
              <div className="flex justify-end gap-4 p-6 border-t">
                <button
                  onClick={() => {
                    setSubCategoryModel(false);
                    setsubCategoryData({ CategoryId: "", name: "", image: null });
                  }}
                  className="px-6 py-2 border border-gray-300 text-gray-700 rounded-lg hover:bg-gray-50 transition-colors font-medium"
                >
                  Cancel
                </button>
                <button
                  onClick={handleSubAddCategory}
                  className="px-6 py-2 bg-gradient-to-r from-purple-600 to-blue-600 text-white rounded-lg hover:from-purple-700 hover:to-blue-700 transition-all duration-200 font-medium"
                >
                  Create Sub Category
                </button>
              </div>
            </div>
          </div>
        )}

  
      </main>
    </div>
  );
}
